// extracted by mini-css-extract-plugin
module.exports = {"root":"az_hFb","positionFixed":"az_iFb","positionAbsolute":"az_jFb","positionSticky":"az_kFb","positionStatic":"az_lFb","positionRelative":"az_mFb"};